import { useEffect, useState } from 'react';

const MAXIMUM_MOBILE_WIDTH = 1094;

export function useIsMobile() {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const isMobileMediaQueryList = window.matchMedia(
			`(max-width: ${MAXIMUM_MOBILE_WIDTH}px)`,
		);
		const handleChange = () => {
			setIsMobile(isMobileMediaQueryList.matches);
		};

		handleChange();
		isMobileMediaQueryList.addEventListener('change', handleChange);
		return () => {
			isMobileMediaQueryList.removeEventListener('change', handleChange);
		};
	}, []);

	return isMobile;
}
